import { useEffect, useState, useRef } from "react";
import zoomIn from "../../assets/images/zoom-in.svg";
import zoomOut from "../../assets/images/zoom-out.svg";
import zoomDefault from "../../assets/images/zoom-default.svg";
import zoomService from "../../services/ZoomService";

function ZoomPanel({ map }) {

    const [buttonsStates, setButtonsStates] = useState({
        zoomIn: true,
        zoomOut: true,
        zoomDefault: true
    });

    const buttons = useRef(null);
    function createButtons() {
        return {
            zoomIn: {
                img: zoomIn,
                alt: "zoom in",
                command: "in",
                limit: zoomService.maxZoom
            },
            zoomOut: {
                img: zoomOut,
                alt: "zoom out",
                command: "out",
                limit: zoomService.minZoom
            },
            zoomDefault: {
                img: zoomDefault,
                alt: "zoom default",
                command: "default",
                limit: zoomService.initialZoom
            }
        }
    }

    function initZoomService() {
        zoomService.init({initialZoom: 1, minZoom: 0.5, maxZoom: 1, onTransform: updateButtonStates, targetObj: map});
        zoomService.addEventListeners();
        buttons.current = createButtons();
    }

    useEffect(() => {
        initZoomService();
        updateButtonStates();
        zoomService.resetZoom();
        zoomService.resetPosition();
        zoomService.applyTransformations();
        // eslint-disable-next-line
    }, []);

    function handleClick(command, limit) {
        zoomService.handleZoomOnPanelButtons(command, limit);
    }

    function updateButtonStates() {
        //Wrap it in a timeout to wait until animation finishes
        setButtonsStates({
            zoomIn: zoomService.currentZoom < zoomService.maxZoom,
            zoomOut: zoomService.currentZoom > zoomService.minZoom,
            zoomDefault: zoomService.currentZoom < zoomService.initialZoom
        })
    }

    return (
        <div className="zoomPanel" aria-hidden="true">
            {buttons.current && Object.keys(buttons.current).map(button => (
                <button
                    key={button}
                    className={`zoom-button ${buttonsStates[button] ? "" : "disabled-button"}`}
                    onClick={() => handleClick(buttons.current[button].command, buttons.current[button].limit)}
                    disabled={!buttonsStates[button]}
                >
                    <img src={buttons.current[button].img} alt={buttons.current[button].alt} />
                </button>
            ))}
        </div>
    );
}

export default ZoomPanel;